var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app_success_page"},[_c('p',{staticClass:"success_"},[_vm._v("预约成功！")]),_c('p',{staticClass:"tip_"},[_vm._v("同样的信息不需要重复预约")]),_c('serviceQrCode',{attrs:{"isFengChannel":_vm.channelSystem == 4,"userId":_vm.$route.query.userId,"type":"success"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }